/* eslint-disable func-names, max-len, no-new, no-underscore-dangle */
/* global NetC:false */
(() => {
  if (!(window.NetC && $('.event-calendar').length)) {
    return;
  }

  const templates = {
    eventCalendarMonth: require('templates/event-calendar-month.hbs'),
    eventItem: require('templates/event-calendar-item.hbs'),
  };

  let typeGuid = '';
  let locationGuid = '';
  let startDate = '';
  let startIndex = 0;
  const count = 20;

  const $eventFilterWrapper = $('.event-filter-wrapper');
  const $eventFilters = $('.event-filter-select', $eventFilterWrapper);
  const $resetBtn = $('.btn-reset', $eventFilterWrapper);

  const $eventWrapper = $('.event-calendar');
  const $eventMonthsWrapper = $('.event-calendar-months', $eventWrapper);
  const $eventItemsWrapper = $('.event-calendar-items', $eventWrapper);
  const $loadMoreBtn = $('.btn-load-more', $eventWrapper);
  const $eventCalendarTitle = $('.event-calendar-title', $eventWrapper);
  const currentAliasPath = $eventWrapper.data('aliaspath');
  const $cultureCode = $('.js-culture-code')
  const cultureCode = $cultureCode.val();

  init();

  function init() {
    initEventFilters();
    initEventMonths();
    initEventItems();

    $resetBtn.click((e) => {
      e.preventDefault();

      typeGuid = '';
      locationGuid = '';
      startDate = '';
      startIndex = 0;

      $eventFilters.each(function () {
        this.selectedIndex = 0;
      }).trigger('chosen:updated');

      loadMonths();
      loadEvents();
    });

    $loadMoreBtn.click((e) => {
      e.preventDefault();
      startIndex += count;
      loadEvents(true);
    });
  }

  function initEventFilters() {
    $eventFilters.change(function () {
      const $filter = $(this);

      startIndex = 0;

      if ($filter.hasClass('event-filter-type')) {
        typeGuid = $filter.val();
      } else if ($filter.hasClass('event-filter-location')) {
        locationGuid = $filter.val();
      }

      loadMonths();
      loadEvents();
    });
  }

  function initEventMonths() {
    loadMonths();
  }

  function initEventItems() {
    loadEvents();
  }

  function loadMonths() {
    NetC.EventCalendar.GetMonthCounts(currentAliasPath, typeGuid, locationGuid, cultureCode, (resp) => {
      // clear existing items
      $eventMonthsWrapper.empty();

      // apply template and append items
      $eventMonthsWrapper.append($.trim(templates.eventCalendarMonth(resp.Data)));

      const $monthLinks = $('.event-month', $eventMonthsWrapper);

      $monthLinks.click(function (e) {
        e.preventDefault();
        startIndex = 0;
        $monthLinks.removeClass('selected');
        startDate = $(this).addClass('selected').data('datetime');
        loadEvents();
      });
    });
  }

  function loadEvents(append) {
    NetC.EventCalendar.GetEvents(currentAliasPath, typeGuid, locationGuid, startDate, startIndex, count, cultureCode, (resp) => {
      // clear existing items
      if (append !== true) {
        $eventItemsWrapper.empty();
      }

      // apply template and append items
      $eventItemsWrapper.append($.trim(templates.eventItem(resp.Data)));

      if (resp.Data.ShowLoadMore === true) {
        $loadMoreBtn.show();
      } else {
        $loadMoreBtn.hide();
      }

      $eventCalendarTitle.html(resp.Data.SelectedMonthFormatted);
    });
  }
})();
